var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedalSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.002C18.6274 24.002 24 18.6294 24 12.002C24 5.37454 18.6274 0.00195312 12 0.00195312C5.37258 0.00195312 0 5.37454 0 12.002C0 18.6294 5.37258 24.002 12 24.002Z",
    fill: "url(#paint0_linear_21983_223289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 21.5672C17.2829 21.5672 21.5653 17.2849 21.5653 12.0024C21.5653 6.71983 17.2829 2.4375 12.0004 2.4375C6.71788 2.4375 2.43555 6.71983 2.43555 12.0024C2.43555 17.2849 6.71788 21.5672 12.0004 21.5672Z",
    fill: "url(#paint1_linear_21983_223289)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 20.214C16.5356 20.214 20.212 16.5376 20.212 12.0025C20.212 7.46742 16.5356 3.79102 12.0006 3.79102C7.46547 3.79102 3.78906 7.46742 3.78906 12.0025C3.78906 16.5376 7.46547 20.214 12.0006 20.214Z",
    fill: "url(#paint2_linear_21983_223289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21983_223289",
    x1: 4.60151,
    y1: 4.60346,
    x2: 17.2573,
    y2: 17.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21983_223289",
    x1: 18.2127,
    y1: 18.2146,
    x2: 5.60688,
    y2: 5.60883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21983_223289",
    x1: 6.03104,
    y1: 6.03299,
    x2: 15.8571,
    y2: 15.8591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSilver);
export default __webpack_public_path__ + "static/media/medal_silver.9dc564dfd8ca37bf3dfdaedb718e223f.svg";
export { ForwardRef as ReactComponent };